import { useEffect } from 'react';

const NAVBAR_HEIGHT = 120;
const LOAD_DELAY = 400;

export const useHashScroll = () => {
  useEffect(() => {
    const scrollToHash = (hash) => {
      if (!hash) return;
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT;
      window.scrollTo({ top, behavior: 'smooth' });
    };

    // Handle direct URL load (e.g. paduaweddings.com/#contact)
    if (window.location.hash) {
      const hash = window.location.hash;
      // Wait for DOM + images to settle before scrolling
      const timer = setTimeout(() => scrollToHash(hash), LOAD_DELAY);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    // Handle in-page hash link clicks
    const handleClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute('href');
      if (!hash || hash === '#') return;
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT;
      window.scrollTo({ top, behavior: 'smooth' });
      // Update URL without triggering a jump
      window.history.pushState(null, '', hash);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
};